import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_CAPITAL_PROVINCE_BY_ID } from "../Schema/CapitalProvince";

export const useGetCapitalProvinceById = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const { refetch } = useQuery(GET_CAPITAL_PROVINCE_BY_ID, {
    variables: {
      id: id,
    },
    onCompleted: ({ getCapitalProvinceById }) => {
   
      setData(getCapitalProvinceById || []);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    refetch();
  }, []);

  return { data, loading, refetch };
};
